import { render, staticRenderFns } from "./NotificationsDialog.vue?vue&type=template&id=76a4aa2c"
import script from "./NotificationsDialog.vue?vue&type=script&lang=js"
export * from "./NotificationsDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationsDialog.vue?vue&type=style&index=0&id=76a4aa2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports